import {Fragment} from 'react'
import {EyeIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import {ForYouItem} from '../shared/ForYouItem'
import {useLayoutQuery} from '../../../../page-data/loaders/use-layout-query'
import {type StackPullRequest, useDownstackPendingReviewRequests} from './use-downstack-pending-review-request'

export function shouldShowStackReviewPreviousFirst(pullRequestsAwaitingReview: StackPullRequest[]): boolean {
  return pullRequestsAwaitingReview.length > 0
}

export function StackReviewPreviousFirst() {
  const {pullRequest, stack} = useLayoutQuery().data
  const {data: pullRequestsAwaitingReview} = useDownstackPendingReviewRequests(stack, pullRequest.number)

  if (!shouldShowStackReviewPreviousFirst(pullRequestsAwaitingReview)) return null

  const isPlural = pullRequestsAwaitingReview.length > 1
  const introText = isPlural ? 'Complete your requested reviews in' : 'Complete your requested review in'
  const pullRequestLinks = pullRequestsAwaitingReview.map((pull, index) => {
    const separator =
      index === 0
        ? ''
        : index < pullRequestsAwaitingReview.length - 1
          ? ', '
          : pullRequestsAwaitingReview.length > 2
            ? ', and '
            : ' and '

    return (
      <Fragment key={pull.number}>
        {separator}
        <Link inline href={pull.url} className="Link--inTextBlock">
          #{pull.number}
        </Link>
      </Fragment>
    )
  })

  return (
    <ForYouItem
      itemId="stack-review-previous-first"
      visual={{kind: 'icon', icon: EyeIcon, tone: 'attention', glyphSize: 12}}
      title={isPlural ? 'Review previous stacked PRs first' : 'Review a previous stacked PR first'}
      subText={
        <>
          {introText} {pullRequestLinks} before reviewing this pull request.
        </>
      }
    />
  )
}
